/*
 * @Author: 陈大仙人
 * @Date: 2023-12-01 17:59:11
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2023-12-01 18:25:03
 * @FilePath: /akx-pc-main/src/util/webviewapi.js
 */
// use-alert.js
let callbackId = 1;

export function webviewAlert(content, title, options, callback) {
  callbackId++;
  const fnName = `alertFnName${callbackId}`;
  window[fnName] = callback;
  if (!options) {
    options = {
      confirmText: '确定',
      cancelText: '取消',
    };
  }
  window.NativeBridge.showDialog(content, title, JSON.stringify(options), fnName);
}